// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 593 ? "framework" : chunkId) + "-" + {"267":"95bff0ee8fcc9f2ae131","556":"d3ded35fa2b98386fdec","593":"89e48458e353b3156743","995":"3e88cc4949ce522c638d"}[chunkId] + ".js";
};